/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PizzaConfigurationResult } from '../../models/pizza-configuration-result';

export interface PizzaConfigurationGet$Params {
  'Active-Tenant-Identifier': string;
}

export function pizzaConfigurationGet(http: HttpClient, rootUrl: string, params: PizzaConfigurationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PizzaConfigurationResult>> {
  const rb = new RequestBuilder(rootUrl, pizzaConfigurationGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PizzaConfigurationResult>;
    })
  );
}

pizzaConfigurationGet.PATH = '/pizza-configuration';
